import { Component, OnInit } from '@angular/core';

import { CustomerService } from 'src/app/services/customer.service';

import { InscripcionConvenioService } from 'src/app/services/inscripcion-convenio.service';

@Component({

  selector: 'app-seguimiento-contrataciones',

  templateUrl: './seguimiento-contrataciones.component.html',

  styleUrls: ['./seguimiento-contrataciones.component.css']

})

export class SeguimientoContratacionesComponent implements OnInit {

  public clientes: any[] = [];

  public clienteSeleccionado: any = null;

  public cargandoClientes = false;

  public contrataciones: any[] = [];

  public cargandoSeguimiento = false;

  public seguimientoCargado = false;

  public mensajeError = '';

  public periodoSeleccionado = '30';

  public periodos: any[] = [

    { id: '7', nombre: 'Última semana' },

    { id: '30', nombre: 'Último mes' },

    { id: '90', nombre: 'Últimos 3 meses' },

    { id: 'all', nombre: 'Todo el histórico' },

    { id: 'custom', nombre: 'Personalizado' }

  ];

  public fechaDesde = '';

  public fechaHasta = '';

  public fechaDesdeTemporal = '';

  public fechaHastaTemporal = '';

  public fechasPendientes = false;

  public tabFlujo = 'todos';

  public searchText = '';

  public filtroEstado = '';

  public filtroPaso = '';

  public filtroEjecutivo = '';

  public currentPage = 1;

  public pageSize = 10;

  public detalleSeleccionado: any = null;

  public mostrarDetalle = false;

  constructor(

    public customerService: CustomerService,

    public inscripcionService: InscripcionConvenioService

  ) {}

  ngOnInit(): void {

    this.configurarPeriodoInicial();

    this.postListarCustomer();

  }

  public postListarCustomer(): void {

    this.cargandoClientes = true;

    this.mensajeError = '';

    this.customerService.postListarCustomer({})

      .then((data: any) => {

        this.clientes = Array.isArray(data) ? data : [];

        this.clienteSeleccionado = this.clientes.length > 0 ? this.clientes[0].cus_id : null;

        this.cargandoClientes = false;

      })

      .catch((error: any) => {

        console.error('[SeguimientoContrataciones] Error clientes:', error);

        this.clientes = [];

        this.clienteSeleccionado = null;

        this.cargandoClientes = false;

        if (error?.status === 403) this.mensajeError = 'Tu perfil no tiene permisos para consultar el listado de clientes.';

        else if (error?.status === 401) this.mensajeError = 'Tu sesión no está autorizada. Vuelve a iniciar sesión.';

        else this.mensajeError = 'No fue posible cargar los clientes.';

      });

  }

  private configurarPeriodoInicial(): void {

    this.periodoSeleccionado = '30';

    const hoy = new Date();

    hoy.setHours(0, 0, 0, 0);

    const desde = new Date(hoy);

    desde.setDate(desde.getDate() - 30);

    this.fechaDesde = this.formatearFechaInput(desde);

    this.fechaHasta = this.formatearFechaInput(hoy);

    this.fechaDesdeTemporal = this.fechaDesde;

    this.fechaHastaTemporal = this.fechaHasta;

    this.fechasPendientes = false;

  }

  public seleccionarPeriodo(periodo: string): void {

    this.mensajeError = '';

    if (periodo === 'custom') {

      this.periodoSeleccionado = 'custom';

      this.fechaDesdeTemporal = this.fechaDesde;

      this.fechaHastaTemporal = this.fechaHasta;

      this.fechasPendientes = false;

      return;

    }

    this.periodoSeleccionado = periodo;

    const hoy = new Date();

    hoy.setHours(0, 0, 0, 0);

    this.fechaHasta = this.formatearFechaInput(hoy);

    if (periodo === 'all') {

      this.fechaDesde = '';

    } else {

      const desde = new Date(hoy);

      desde.setDate(desde.getDate() - Number(periodo));

      this.fechaDesde = this.formatearFechaInput(desde);

    }

    this.fechaDesdeTemporal = this.fechaDesde;

    this.fechaHastaTemporal = this.fechaHasta;

    this.fechasPendientes = false;

    if (this.seguimientoCargado) this.consultarSeguimiento();

  }

  public onClienteChange(): void {

    this.mensajeError = '';

    this.seguimientoCargado = false;

    this.contrataciones = [];

    this.resetFiltrosTabla();

  }

  public onFechaChange(): void {

    this.periodoSeleccionado = 'custom';

    this.fechasPendientes = true;

    this.mensajeError = '';

  }

  public aplicarFechas(): void {

    this.mensajeError = '';

    if (!this.fechaDesdeTemporal || !this.fechaHastaTemporal) {

      this.mensajeError = 'Debes seleccionar una fecha desde y una fecha hasta.';

      return;

    }

    if (this.fechaDesdeTemporal > this.fechaHastaTemporal) {

      this.mensajeError = 'La fecha desde no puede ser mayor a la fecha hasta.';

      return;

    }

    this.fechaDesde = this.fechaDesdeTemporal;

    this.fechaHasta = this.fechaHastaTemporal;

    this.periodoSeleccionado = 'custom';

    this.fechasPendientes = false;

    if (this.seguimientoCargado) this.consultarSeguimiento();

  }

  public verSeguimiento(): void {

    this.mensajeError = '';

    if (!this.clienteSeleccionado) {

      this.mensajeError = 'Debes seleccionar un cliente.';

      return;

    }

    if (this.periodoSeleccionado === 'custom' && this.fechasPendientes) {

      this.mensajeError = 'Debes aplicar el rango de fechas antes de continuar.';

      return;

    }

    if (this.periodoSeleccionado !== 'all' && (!this.fechaDesde || !this.fechaHasta)) {

      this.mensajeError = 'Debes seleccionar un período válido.';

      return;

    }

    if (this.fechaDesde && this.fechaHasta && this.fechaDesde > this.fechaHasta) {

      this.mensajeError = 'La fecha desde no puede ser mayor a la fecha hasta.';

      return;

    }

    this.consultarSeguimiento();

  }

  private consultarSeguimiento(): void {

    if (this.cargandoSeguimiento) return;

    this.mensajeError = '';

    this.cargandoSeguimiento = true;

    const params = {

      cusBenCusId: String(this.clienteSeleccionado),

      subCarCreatedFrom: this.fechaDesde || null,

      subCarCreatedTo: this.fechaHasta || null

    };

    console.log('[SeguimientoContrataciones] Request:', params);

    this.inscripcionService.getListarContrataciones(params)

      .then((data: any) => {

        console.log('[SeguimientoContrataciones] Response:', data);

        if (Array.isArray(data)) this.contrataciones = data;

        else if (Array.isArray(data?.data)) this.contrataciones = data.data;

        else if (Array.isArray(data?.rows)) this.contrataciones = data.rows;

        else this.contrataciones = [];

        this.seguimientoCargado = true;

        this.cargandoSeguimiento = false;

        this.resetFiltrosTabla();

      })

      .catch((error: any) => {

        console.error('[SeguimientoContrataciones] Error:', error);

        this.contrataciones = [];

        this.seguimientoCargado = false;

        this.cargandoSeguimiento = false;

        if (error?.status === 403) this.mensajeError = 'Tu perfil no tiene permisos para consultar las contrataciones.';

        else if (error?.status === 401) this.mensajeError = 'Tu sesión no está autorizada. Vuelve a iniciar sesión.';

        else this.mensajeError = 'No fue posible cargar las contrataciones.';

      });

  }

  private resetFiltrosTabla(): void {

    this.tabFlujo = 'todos';

    this.searchText = '';

    this.filtroEstado = '';

    this.filtroPaso = '';

    this.filtroEjecutivo = '';

    this.currentPage = 1;

  }

  public seleccionarTab(tab: string): void {

    this.tabFlujo = tab;

    this.currentPage = 1;

  }

  public onFiltroChange(): void {

    this.currentPage = 1;

  }

  public getPasoNumero(item: any): number {

    const estado = Number(item?.sub_car_sta_id);

    if (estado === 131 || estado === 132) return 3;

    if (estado === 133) return 4;

    if (estado === 134) return 5;

    if (estado === 135) return 5;

    return 0;

  }

  public getPasoNombre(item: any): string {

    const paso = this.getPasoNumero(item);

    if (paso === 3) return 'Beneficiarios';

    if (paso === 4) return 'Pago';

    if (paso === 5) return 'Inscripción activa';

    return 'Sin información';

  }

  public getPasoTexto(item: any): string {

    const paso = this.getPasoNumero(item);

    if (paso === 5) return 'Completado';

    if (!paso) return 'Sin información';

    return 'Paso ' + paso + ' de 5';

  }

  public getFlujo(item: any): string {

  const origen = String(item?.sub_car_origin || '').trim().toUpperCase();

  return origen === 'PATIENT' ? 'Directa' : 'Asistido';

}

  public getEstadoSeguimiento(item: any): string {

  const estado = Number(item?.sub_car_sta_id);

  const paso = this.getPasoNumero(item);

  // Si llegó al paso 5, la suscripción se completó.

  // Nunca puede considerarse olvidada.

  if (estado === 135 || paso === 5) {

    return 'Completado';

  }

  // Si existe una condición explícita de carrito caducado.

  if (

    item?.is_caducado === true ||

    item?.sub_car_is_expired === true ||

    item?.sub_car_expired === true

  ) {

    return 'Caducado';

  }

  const estadoBackend = this.normalizarTexto(

    item?.estado_seguimiento ||

    item?.status_name ||

    item?.sta_name ||

    item?.sub_car_status_name

  );

  if (estadoBackend.indexOf('CADUC') >= 0) {

    return 'Caducado';

  }

  // Solo pueden ser olvidados los formularios que NO terminaron

  // el flujo y llevan más de 48 horas sin actividad.

  if ([131, 132, 134].indexOf(estado) >= 0) {

    if (this.getHorasSinActividad(item) > 48) {

      return 'Olvidado';

    }

    return 'En curso';

  }

  return 'En curso';

}

  public getEstadoClass(item: any): string {

    const estado = this.getEstadoSeguimiento(item);

    if (estado === 'Completado') return 'estado-completado';

    if (estado === 'Caducado') return 'estado-caducado';

    if (estado === 'Olvidado') return 'estado-olvidado';

    return 'estado-curso';

  }

  public getTitularNombre(item: any): string {

    if (item?.titular_nombre_completo) return item.titular_nombre_completo;

    const nombre = item?.titular_nombre || item?.sub_car_det_name || item?.name || '';

    const paterno = item?.titular_apellido_paterno || item?.sub_car_det_paternal_surname || '';

    const materno = item?.titular_apellido_materno || item?.sub_car_det_maternal_surname || '';

    return [nombre, paterno, materno].filter((x: any) => !!x).join(' ') || 'Sin nombre';

  }

  public getTitularRut(item: any): string {

    return item?.titular_rut || item?.sub_car_det_rut || item?.rut || '—';

  }

  public getTitularEmail(item: any): string {

    return item?.titular_email || item?.sub_car_det_email || item?.email || '';

  }

  public getTitularTelefono(item: any): string {

    return item?.titular_telefono || item?.sub_car_det_phone || item?.phone || item?.movil || '';

  }

  public getEjecutivo(item: any): string {

  if (this.getFlujo(item) === 'Directa') {

    return 'Sin asignar';

  }

  return item?.sub_car_seller_name || 'Sin asignar';

}

  public getPlanNombre(item: any): string {

    return item?.plan_nombre || item?.cus_ben_name || item?.benefit_name || '—';

  }

  public getBeneficiarios(item: any): number {

    return Number(item?.sub_cant_beneficiarios ?? item?.cantidad_beneficiarios ?? item?.beneficiarios ?? 0);

  }

  public getFechaInicio(item: any): string {

    const value = item?.fecha_inicio || item?.sub_car_created_at || item?.sub_car_creation_date || item?.sub_car_created_date;

    return this.formatearFechaBackend(value);

  }

  private getFechaUltimaActividad(item: any): Date | null {

    const value =

      item?.ultima_actividad ||

      item?.sub_car_updated_at ||

      item?.sub_car_update_date ||

      item?.sub_car_last_activity ||

      item?.sub_car_paid_at ||

      item?.sub_car_confirmed_at ||

      item?.fecha_inicio ||

      item?.sub_car_created_at;

    return this.parseDate(value);

  }

  public getUltimaActividadTexto(item: any): string {

    const fecha = this.getFechaUltimaActividad(item);

    if (!fecha) return 'Sin información';

    const diferencia = new Date().getTime() - fecha.getTime();

    const minutos = Math.max(0, Math.floor(diferencia / 60000));

    if (minutos < 60) return minutos <= 1 ? 'hace 1 minuto' : 'hace ' + minutos + ' minutos';

    const horas = Math.floor(minutos / 60);

    if (horas < 24) return horas === 1 ? 'hace 1 hora' : 'hace ' + horas + ' horas';

    const dias = Math.floor(horas / 24);

    return dias === 1 ? 'hace 1 día' : 'hace ' + dias + ' días';

  }

  public getHorasSinActividad(item: any): number {

    if (item?.horas_sin_actividad !== undefined && item?.horas_sin_actividad !== null) {

      return Number(item.horas_sin_actividad) || 0;

    }

    const fecha = this.getFechaUltimaActividad(item);

    if (!fecha) return 0;

    return Math.floor((new Date().getTime() - fecha.getTime()) / 3600000);

  }

  public get totalFormularios(): number {

    return this.contrataciones.length;

  }

  public get totalEnCurso(): number {

    return this.contrataciones.filter((item: any) => this.getEstadoSeguimiento(item) === 'En curso').length;

  }

  public get totalCompletados(): number {

    return this.contrataciones.filter((item: any) => this.getEstadoSeguimiento(item) === 'Completado').length;

  }

  public get totalOlvidados(): number {

    return this.contrataciones.filter((item: any) => this.getEstadoSeguimiento(item) === 'Olvidado').length;

  }

  public get totalCaducados(): number {

    return this.contrataciones.filter((item: any) => this.getEstadoSeguimiento(item) === 'Caducado').length;

  }

  public get ejecutivosDisponibles(): string[] {

    const nombres: string[] = [];

    this.contrataciones.forEach((item: any) => {

      const nombre = this.getEjecutivo(item);

      if (nombre && nombres.indexOf(nombre) === -1) nombres.push(nombre);

    });

    return nombres.sort();

  }

  public get contratacionesFiltradas(): any[] {

    const search = this.normalizarTexto(this.searchText);

    return this.contrataciones.filter((item: any) => {

      if (this.tabFlujo === 'directa' && this.getFlujo(item) !== 'Directa') return false;

      if (this.tabFlujo === 'asistido' && this.getFlujo(item) !== 'Asistido') return false;

      if (search) {

        const texto = this.normalizarTexto(this.getTitularNombre(item) + ' ' + this.getTitularRut(item));

        if (texto.indexOf(search) === -1) return false;

      }

      if (this.filtroEstado && this.getEstadoSeguimiento(item) !== this.filtroEstado) return false;

      if (this.filtroPaso && String(this.getPasoNumero(item)) !== String(this.filtroPaso)) return false;

      if (this.filtroEjecutivo && this.getEjecutivo(item) !== this.filtroEjecutivo) return false;

      return true;

    }).sort((a: any, b: any) => {

      const fechaA = this.getFechaUltimaActividad(a);

      const fechaB = this.getFechaUltimaActividad(b);

      if (!fechaA && !fechaB) return 0;

      if (!fechaA) return -1;

      if (!fechaB) return 1;

      return fechaA.getTime() - fechaB.getTime();

    });

  }

  public get contratacionesPaginadas(): any[] {

    const inicio = (this.currentPage - 1) * this.pageSize;

    return this.contratacionesFiltradas.slice(inicio, inicio + this.pageSize);

  }

  public get totalFiltradas(): number {

    return this.contratacionesFiltradas.length;

  }

  public get totalPages(): number {

    return Math.max(1, Math.ceil(this.totalFiltradas / this.pageSize));

  }

  public get firstVisibleItem(): number {

    if (!this.totalFiltradas) return 0;

    return ((this.currentPage - 1) * this.pageSize) + 1;

  }

  public get lastVisibleItem(): number {

    return Math.min(this.currentPage * this.pageSize, this.totalFiltradas);

  }

  public previousPage(): void {

    if (this.currentPage > 1) this.currentPage--;

  }

  public nextPage(): void {

    if (this.currentPage < this.totalPages) this.currentPage++;

  }

  public irPagina(page: number): void {

    if (page >= 1 && page <= this.totalPages) this.currentPage = page;

  }

  public get paginasVisibles(): number[] {

    const paginas: number[] = [];

    const desde = Math.max(1, this.currentPage - 2);

    const hasta = Math.min(this.totalPages, this.currentPage + 2);

    for (let i = desde; i <= hasta; i++) paginas.push(i);

    return paginas;

  }

  public abrirDetalle(item: any): void {

    this.detalleSeleccionado = item;

    this.mostrarDetalle = true;

  }

  public cerrarDetalle(): void {

    this.mostrarDetalle = false;

    this.detalleSeleccionado = null;

  }

  public getDescripcionEstado(item: any): string {

    const estado = this.getEstadoSeguimiento(item);

    if (estado === 'Completado') return 'La inscripción fue completada correctamente.';

    if (estado === 'Olvidado') return 'El proceso lleva más de 48 horas sin actividad y todavía se encuentra pendiente.';

    if (estado === 'Caducado') return 'El carrito fue invalidado debido a un cambio en las condiciones del plan.';

    return 'La inscripción todavía se encuentra en proceso.';

  }

  public esContratacionCompletada(item: any): boolean {

  return this.getPasoNumero(item) === 5 || Number(item?.sub_car_sta_id) === 135;

}

public esContratacionOlvidada(item: any): boolean {

  return this.getEstadoSeguimiento(item) === 'Olvidado';

}

public tieneComunicacionesAutomaticas(item: any): boolean {

  return this.esContratacionCompletada(item) || this.esContratacionOlvidada(item);

}

public getFechaSolicitudInscripcion(item: any): string {

  const fecha = this.getFechaUltimaActividad(item);

  return this.formatearFechaComunicacion(fecha);

}

public getFechaRecordatorioPendiente(item: any): string {

  const fechaInicio = this.getFechaInicioDate(item);

  if (!fechaInicio) {

    return 'Fecha no disponible';

  }

  const fechaRecordatorio = new Date(fechaInicio);

  fechaRecordatorio.setDate(fechaRecordatorio.getDate() + 1);

  fechaRecordatorio.setHours(9, 0, 0, 0);

  return this.formatearFechaComunicacion(fechaRecordatorio);

}

private getFechaInicioDate(item: any): Date | null {

  const value =

    item?.fecha_inicio ||

    item?.sub_car_created_at ||

    item?.sub_car_creation_date ||

    item?.sub_car_created_date;

  return this.parseDate(value);

}

private formatearFechaComunicacion(fecha: Date | null): string {

  if (!fecha) {

    return 'Fecha no disponible';

  }

  const meses = [

    'ene', 'feb', 'mar', 'abr', 'may', 'jun',

    'jul', 'ago', 'sep', 'oct', 'nov', 'dic'

  ];

  const dia = ('0' + fecha.getDate()).slice(-2);

  const mes = meses[fecha.getMonth()];

  const hora = ('0' + fecha.getHours()).slice(-2);

  const minutos = ('0' + fecha.getMinutes()).slice(-2);

  return 'Mail · ' + dia + ' ' + mes + ' · ' + hora + ':' + minutos;

}

  public getPasoTimelineClass(item: any, paso: number): string {

    const actual = this.getPasoNumero(item);

    const estado = this.getEstadoSeguimiento(item);

    if (estado === 'Completado' || paso < actual) return 'timeline-ok';

    if (paso === actual && estado === 'Caducado') return 'timeline-error';

    if (paso === actual) return 'timeline-current';

    return 'timeline-pending';

  }

  public getPasoTimelineTexto(item: any, paso: number): string {

    const actual = this.getPasoNumero(item);

    const estado = this.getEstadoSeguimiento(item);

    if (estado === 'Completado' || paso < actual) return 'Completado';

    if (paso === actual && estado === 'Caducado') return 'Caducado';

    if (paso === actual) return 'En curso';

    return 'Pendiente';

  }

  public get nombrePeriodoSeleccionado(): string {

    const periodo = this.periodos.find((item: any) => item.id === this.periodoSeleccionado);

    return periodo ? periodo.nombre : '';

  }

  public get textoPeriodoCorto(): string {

    if (this.periodoSeleccionado === '7') return 'en la última semana';

    if (this.periodoSeleccionado === '30') return 'en el último mes';

    if (this.periodoSeleccionado === '90') return 'en los últimos 3 meses';

    if (this.periodoSeleccionado === 'all') return 'en todo el histórico';

    return 'en el período seleccionado';

  }

  public get resumenPeriodo(): string {

    if (!this.fechaHasta) return '';

    if (this.periodoSeleccionado === 'all') {

      return 'Mostrando Todo el histórico · Hasta ' + this.formatearFechaVista(this.fechaHasta);

    }

    if (!this.fechaDesde) return '';

    return 'Mostrando ' + this.nombrePeriodoSeleccionado + ' · ' +

      this.formatearFechaVista(this.fechaDesde) + ' – ' +

      this.formatearFechaVista(this.fechaHasta);

  }

  public get clienteSeleccionadoData(): any {

    if (!this.clienteSeleccionado) return null;

    return this.clientes.find(

      (cliente: any) => Number(cliente?.cus_id) === Number(this.clienteSeleccionado)

    ) || null;

  }

  public get clienteNombreSeleccionado(): string {

    return this.clienteSeleccionadoData?.cus_name || '';

  }

  public exportarCSV(): void {
    if (!this.contratacionesFiltradas.length) return;

    const filas = this.contratacionesFiltradas.map((item: any) => [
      this.getTitularNombre(item),
      this.getTitularRut(item),
      this.getFlujo(item),
      this.getEjecutivo(item),
      this.getFechaInicio(item),
      this.getPasoTexto(item),
      this.getEstadoSeguimiento(item),
      this.getUltimaActividadTexto(item),
      this.getPlanNombre(item),
      this.getBeneficiarios(item),
      this.getTitularTelefono(item),
      this.getTitularEmail(item)
    ]);

    const encabezado = [
      'Titular',
      'RUT',
      'Flujo',
      'Ejecutivo',
      'Fecha de inicio',
      'Paso alcanzado',
      'Estado',
      'Última actividad',
      'Plan',
      'Beneficiarios',
      'Teléfono',
      'Email'
    ];

    const contenido = [encabezado, ...filas]
      .map((fila: any[]) =>
        fila.map((valor: any) => '"' + String(valor ?? '').replace(/"/g, '""') + '"').join(';')
      )
      .join('\n');

    const blob = new Blob(['\ufeff' + contenido], {
      type: 'text/csv;charset=utf-8;'
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = 'seguimiento_contrataciones.csv';
    link.click();

    URL.revokeObjectURL(url);
  }

  private formatearFechaInput(fecha: Date): string {

    const year = fecha.getFullYear();

    const month = ('0' + (fecha.getMonth() + 1)).slice(-2);

    const day = ('0' + fecha.getDate()).slice(-2);

    return year + '-' + month + '-' + day;

  }

  public formatearFechaVista(fecha: string): string {

    if (!fecha) return '';

    const partes = fecha.split('-');

    if (partes.length !== 3) return fecha;

    return partes[2] + '-' + partes[1] + '-' + partes[0];

  }

  private formatearFechaBackend(value: any): string {

    const fecha = this.parseDate(value);

    if (!fecha) return '—';

    const dia = ('0' + fecha.getDate()).slice(-2);

    const mes = ('0' + (fecha.getMonth() + 1)).slice(-2);

    return dia + '-' + mes + '-' + fecha.getFullYear();

  }

  private parseDate(value: any): Date | null {

    if (!value) return null;

    if (value instanceof Date) {

      return isNaN(value.getTime()) ? null : value;

    }

    const fecha = new Date(value);

    return isNaN(fecha.getTime()) ? null : fecha;

  }

  private normalizarTexto(value: any): string {

    return String(value || '')

      .trim()

      .toUpperCase()

      .normalize('NFD')

      .replace(/[\u0300-\u036f]/g, '');

  }

}
